









import { isInRole } from '@/lib/auth'

export default {
  props: {
    group: String,
    groups: Array
  },
  data: function() {
    return {
      hasPermission: false
    }
  },
  watch: {
    '$store.state.clientId': function() {
      this.checkPermissions()
    }
  },
  mounted() {
    this.checkPermissions()
  },
  methods: {
    checkPermissions() {
      isInRole(this.group, this.groups).then(
        inRole => (this.hasPermission = inRole)
      )
    }
  }
}
